import MinimumCqlScoreWidget from './../MinimumCqlScoreWidget'
import { withProps } from 'recompose'
import { setMinimumCqlScore, getMinimumCqlScore } from 'app/modules/integrations/api'

export const model = [
  {
    type: 'createNewHubSpotLeadsEnabled',
    value: false,
    label: 'Sync leads from Drift to Hubspot',
    description: 'New leads from Drift will be created in HubSpot',
  },
  {
    type: 'leadOwnerMappingEnabled',
    value: false,
    label: 'Set Lead Owner in Hubspot',
    description: 'For each contact that Drift creates, set the Lead Owner in HubSpot based on who had a meeting booked, who was routed, or who closed the conversation in that order. Requires Drift user mappings.',
    children: {
      label: 'Overwrite existing HubSpot owner if present',
      description: 'If there is an existing lead owner in Hubspot, overwrite with the latest person involved from Drift',
      topLevelAdvancedItems: [],
      items: [
        {
          type: 'leadOwnerOverwriteEnabled',
          label: 'Enable overwrite',
          value: false
        }
      ]
    }
  },
  {
    type: 'hasTimelineEnabled',
    value: false,
    label: 'Send Drift activity data to HubSpot',
    description: 'When a contact has a conversation with you in Drift, it’ll be logged in HubSpot',
  },
  {
    type: 'hasTranscriptPushEnabled',
    value: false,
    label: 'Send Conversation Transcripts to HubSpot',
    description: 'When conversation closes in Drift, send a contact timeline activity which includes the conversation transcript to HubSpot',
  },
  {
    type: 'shouldOnlySyncQualifiedLeads',
    value: false,
    label: 'Set a minimum CQL score for synced contacts and conversations',
    description: 'This option will enable filtering of data pushes into HubSpot based on the most recent CQL score.',
    children: {
      autoExpand: true,
      label: 'Minimum CQL score',
      description: 'Drift will only sync conversations that have the selected CQL score or higher.',
      topLevelAdvancedItems: [],
      advancedComponent: withProps({
        integrationName: 'hubspot',
        setMinimumCQLScore: (data) => setMinimumCqlScore(data),
        getMinimumCQLScore: (data) => getMinimumCqlScore(data)
      })(MinimumCqlScoreWidget),
      items: []
    }
  },
  {
    type: 'createOnlyOnCloseEnabled', // conditionally rendered on toggle 0 in index.js (should sync contacts).
    value: false,
    label: 'Create Contact only on Conversation Closed',
    description: 'This will delay creation of contacts from Drift to Hubspot until a conversation closes'
  },
  {
    type: 'hasCookieIntegrationEnabled',
    value: false,
    label: 'Identify Drift visitors with the HubSpot cookie',
    description: `If someone was already identified by HubSpot, Drift will automatically recognize them as a known contact. We'll only check HubSpot if the visitor has a HubSpot cookie set.`,
  }
]

const addValuesToToggles = (toggles, fullToggles) => {
  return toggles.map(secondLevel => {
    const updatedSecondaryToggle = Object.assign({}, secondLevel)
    updatedSecondaryToggle.value = !!fullToggles[secondLevel.type]
    return updatedSecondaryToggle
  })
}

export const hydrateModel = toggles => {
  return [...model].map(topLevel => {
    const updatedToggle = Object.assign({}, topLevel)
    updatedToggle.value = toggles[topLevel.type]
    if (!!topLevel.children && topLevel.children.items.length > 0) {
      updatedToggle.children.items = addValuesToToggles(topLevel.children.items, toggles)
    }
    return updatedToggle
  })
}



// WEBPACK FOOTER //
// ./src/scripts/components/Integration/pages/HubspotConfig/model.js